import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {white} from '../themes/colors';
import {DEFAULT_AVATAR} from '../constants/constants';
import {getName, isDefaultAvatar} from '../utils/userUtility';
import Image from './Image';
import UserInitials from './userInitials/UserInitials';
import NotificationUnreadBadge from "../containers/main/NotificationUnreadBadge";

const baseIconStyle = {
    color: white,
    verticalAlign: 'middle',
    height: '40px',
    width: '40px',
    borderRadius: '50%',
    objectFit: 'cover',
    objectPosition: 'center'
};

const containerStyle = {
    background: white,
    borderRadius: '50%'
};

const AvatarIcon = ({icon, iconStyle, className, style, useDefault = true, fullName, showOnlineStatus = false, isOnline, isOnProject = false, tooltipText }) => (
    <span className="flex-center avatar-icon" style={{...containerStyle, ...style}}>
        {isDefaultAvatar(icon) && useDefault
            ? <UserInitials fullName={fullName || getName()} />
            : <Image
                className={className}
                style={{...baseIconStyle, ...iconStyle}}
                src={icon}
                defaultImage={DEFAULT_AVATAR}
                alt="avatar"/>
        }
        {showOnlineStatus && <NotificationUnreadBadge count={1} innerClassName={`${isOnline ? 'online' : 'offline'} ${isOnProject ? 'onproject' : ''}`}/>}
        {tooltipText && <div className="button-tooltip">{tooltipText}</div>}
    </span>
);

AvatarIcon.propTypes = {
    icon: PropTypes.string,
    iconStyle: PropTypes.object,
    className: PropTypes.string,
    useDefault: PropTypes.bool,
    fullName: PropTypes.string,
    style: PropTypes.object,
    showOnlineStatus: PropTypes.bool,
    isOnline: PropTypes.bool,
    isOnProject: PropTypes.bool
};

export default observer(AvatarIcon);
